import React from "react";
import Login from "../components/Login/Login";
import Footer from "../components/Footer/Footer"; // ✅ Ensure Footer is included

const LoginPage = () => {
  return (
    <div className="flex flex-col min-h-screen justify-between bg-gray-100">
      <div className="flex-1 flex justify-center items-center">
        <Login />
      </div>
      <div className="mb"> {/* ✅ Added margin to prevent overlapping */}
        <Footer />
      </div>
    </div>
  );
};

export default LoginPage;
